import __request__ from 'routing/request';
interface JsonNode {
}
/**
 * Unused endpoint for MCP protocol compatibility
 */
export function get(): Promise<unknown> {
    return __request__('GET', '/mcp', null, {}, {
        'Accept': ['text/event-stream']
    });
}
/**
 * JSON-RPC endpoint for MCP clients to connect to
 * @param jsonrpc_message jsonrpc_message
 */
export function post(jsonrpc_message: JsonNode): Promise<unknown> {
    return __request__('POST', '/mcp', jsonrpc_message, {}, {
        'Accept': ['application/json']
    });
}
